import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgWizardService } from 'ng-wizard';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-qualifier-whitelisting',
  templateUrl: './qualifier-whitelisting.component.html',
  styleUrls: ['./qualifier-whitelisting.component.scss']
})
export class QualifierWhitelistingComponent implements OnInit {
  flag = true;
  @Output() qualifierwhitelisting: EventEmitter<boolean> = new EventEmitter();
  @Input() schemeId = "";
  qualifierWhitelistUser:any =[];
  page =1;
  getPaginationCount;
  excelFormat: any = {};
  excelArray: any = [];
  excelData: any = [];
  cartonLocalFlags: any = {};
  schemeWhiteList: any = []
  schemeConfig: any = {}  

  constructor(
    private ngWizardService: NgWizardService,
    private router: Router,
    private exportExcelService: ExportExcelService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration

  ) { }

  ngOnInit() {
    this.schemeConfig = JSON.parse(localStorage.getItem('scheme_config'))
    console.log("cap", this.schemeId)
    if (this.schemeConfig.scheme_id != '' && this.schemeConfig.scheme_id != null && this.schemeConfig.scheme_id != undefined) {
      this.schemeId = this.schemeConfig.scheme_id
      this.getQualifierWhitelist()
    }
    this.getQualifierWhitelist()
  }
  getQualifierWhitelist(){
    this.apiService.get(this.apiConfig.getQualifierList + `?scheme_id=${this.schemeId}`).subscribe((res:any)=>{
      console.log(res)
      this.qualifierWhitelistUser = res.data
      this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')
    })
  }
  submit(){
    this.qualifierwhitelisting.emit(this.flag)
  }
  uploadExcel() {
    this.router.navigate([`/hubAdmin/scheme-excel-upload/${this.schemeId}/3`])
  }
  DownloadReportExcel() {
    console.log("here", this.excelData, this.excelArray)
    this.exportExcelService.DownloadReportExcel('Whitelist_outlet', this.excelData, this.excelArray);
  }
  paginationClick(e) {
    console.log(e);
    this.page = e;
  }


}
